module.exports = __webpack_public_path__ + "img/zhejiang.651c9ad.png";